import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'redux'

import { getCurrentStand } from '../../selectors/menus'

import IconExit from '../components/icons/IconExit'

export class Menu extends Component {
  static propTypes = {
    standName: PropTypes.string.isRequired,
    redirectTo: PropTypes.string
  }

  static defaultProps = {
    redirectTo: '/kiosk/attract_loop'
  }

  render() {
    const { standName, redirectTo } = this.props
    return (
      <Fragment>
        <NavLink
          className="menu__exit"
          to={redirectTo}
        >
          <IconExit className="menu__icon" />
          Exit
        </NavLink>
        <div className="menu__top">
          <div className="menu__brand">{standName}</div>
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  standName: getCurrentStand(state).name,
})

export default compose(
  withRouter,
  connect(mapStateToProps),
)(Menu)
